import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";
import {
    CreateInstalledBaseNodeAttributeOptionValue
} from "../../graphql/mutations/createInstalledBaseNodeAttributeOptionValue";
import {
    InstalledBaseNodeAttributeOptionValueListTDAs
} from "../../graphql/queries/installedBaseNodeAttributeOptionValueListTDAs";

interface Props {
    attributeId: string;
    open: boolean,
    onClose?: () => void,
}

const AddAttributeOptionValueModal = ({attributeId, onClose, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [createOptionValue] = useMutation(CreateInstalledBaseNodeAttributeOptionValue);

    const {data} = useQuery(InstalledBaseNodeAttributeOptionValueListTDAs, {
        variables: {
            id: attributeId,
            typeDefinitionIndex: "PROPERTY_OPTION_VALUE_CREATE"
        },
        fetchPolicy: "network-only",
    })

    const handleSubmit = (input: any) => {
        return createOptionValue({
                variables: {
                    id: attributeId,
                    input: input
                },
                refetchQueries: ["InstalledBaseNodeAttribute", "InstalledBaseNodeAttributeOptionValueList"]
            }
        ).then((res) => {
            if (res.data?.createInstalledBaseNodePropertyOptionValue?.id && res.data?.createInstalledBaseNodePropertyOptionValue?.label) {
                toast.success(t("Successfully added optionValue ") + res.data.createInstalledBaseNodePropertyOptionValue.label);
            } else {
                toast.error(t("Error adding option value."))
            }
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            console.log(err, 'ERROR')
            toast.error(resolveErrorMessage(err, t))
        })
    }

    const attributes = _.get(data, 'installedBaseNodePropertyOptionValueList.typeDefinitionAttributeList.typeDefinitionAttributes', [])

    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent title={t('Add a new option value to the attribute')} onClose={onClose}>
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Add option value')}
                attributes={attributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default AddAttributeOptionValueModal;
